// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"510":"0edc0396","588":"298968a6","840":"dbe980ea","976":"8c78e322"}[chunkId] + ".js";
};